import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { authFormWidthSx, authPageSx } from "./authPage.styles";

interface AuthPageShellProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

const AuthPageShell: React.FC<AuthPageShellProps> = ({
  title,
  subtitle,
  children,
}) => {
  const theme = useTheme();
  const logoSrc =
    theme.palette.mode === "dark"
      ? new URL("/images/zero_dark.png", import.meta.url).href
      : new URL("/images/zero_light.png", import.meta.url).href;

  return (
    <Box component="main" sx={authPageSx}>
      <Box sx={authFormWidthSx}>
        <Box sx={{ mb: 4, textAlign: "center" }}>
          <Box
            component="img"
            src={logoSrc}
            alt="Recyclee Zero"
            sx={{ height: 52, mb: 3, display: "inline-block" }}
          />
          <Typography
            component="h1"
            variant="h4"
            sx={{ fontWeight: 700, mb: 1, letterSpacing: "-0.02em" }}
          >
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body1" color="text.secondary">
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        {children}
      </Box>
    </Box>
  );
};

export default AuthPageShell;
